
import { Disc, Calendar, DollarSign, MessageSquare } from "lucide-react";
import { DashboardFeature } from "./types";

export const djFeatures: DashboardFeature[] = [
  {
    icon: Disc,
    title: "DJ Profile",
    description: "Manage your DJ profile",
    href: "/dashboard/dj/profile",
  },
  {
    icon: Calendar,
    title: "Gig Calendar",
    description: "View and manage your gigs",
    href: "/dashboard/dj/gigs",
  },
  {
    icon: DollarSign,
    title: "Earnings",
    description: "Track your earnings",
    href: "/dashboard/dj/earnings",
  },
  {
    icon: MessageSquare,
    title: "Booking Requests",
    description: "Manage booking requests",
    href: "/dashboard/dj/bookings",
  }
];
